import React from 'react';
import PropTypes from 'prop-types';
import stylePropType from 'react-style-proptype';
import * as HoverCard from '@radix-ui/react-hover-card';
import Tokens from 'styles/tokens';

const AvomaHoverCard = ({
  triggerComponent,
  children,
  childrenStyles,
  contentStyles,
  contentProps,
  title = null,
  openDelay = 100,
  closeDelay = 100,
  contentClasses = '',
  portalContainer = document.body, // Use when the hover card needs to be rendered inside another portal like a Modal,
  open, // open and onOpenChange for when the hover card needs to be controlled
  onOpenChange
}) => (
  <HoverCard.Root
    openDelay={openDelay}
    closeDelay={closeDelay}
    open={open}
    onOpenChange={onOpenChange}
  >
    <HoverCard.Trigger asChild>{triggerComponent}</HoverCard.Trigger>
    {children && (
      <HoverCard.Portal container={portalContainer}>
        <HoverCard.Content
          sideOffset={2}
          style={{ ...styles.content, ...contentStyles }}
          className={contentClasses}
          collisionPadding={{ top: 25, right: 25, bottom: 25, left: 25 }}
          collisionBoundary={portalContainer}
          {...contentProps}
        >
          {title && <p style={styles.title}>{title}</p>}
          <div style={{ ...styles.children, ...childrenStyles }}>
            {children}
          </div>
        </HoverCard.Content>
      </HoverCard.Portal>
    )}
  </HoverCard.Root>
);

const styles = {
  content: {
    ...Tokens.shadows.medium,
    width: 300,
    borderRadius: Tokens.spacing.borderRadius,
    border: Tokens.borders.standard
  },
  children: {
    background: Tokens.colors.white,
    padding: `${Tokens.spacing.one} ${Tokens.spacing.two}`,
    borderRadius: Tokens.spacing.borderRadius
  },
  title: {
    ...Tokens.type.body,
    fontWeight: 'bold',
    color: Tokens.colors.black,
    padding: `${Tokens.spacing.one} ${Tokens.spacing.two}`,
    borderBottom: `1px solid ${Tokens.colors.gainsboro}`,
    backgroundColor: Tokens.colors.snow,
    borderTopLeftRadius: Tokens.spacing.borderRadius,
    borderTopRightRadius: Tokens.spacing.borderRadius
  }
};

AvomaHoverCard.propTypes = {
  children: PropTypes.node,
  triggerComponent: PropTypes.node,
  childrenStyles: stylePropType,
  contentStyles: stylePropType,
  contentProps: PropTypes.object,
  title: PropTypes.string,
  openDelay: PropTypes.number,
  closeDelay: PropTypes.number,
  portalContainer: PropTypes.instanceOf(Element),
  contentClasses: PropTypes.string,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func
};

export default AvomaHoverCard;
